import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

export const Error = (props) => {
    const navigate = useNavigate();

    const goDashboard = () => {
        navigate('/');
    };

    return (
        <div className="exception-body error">
            <div className="exception-panel">
                <h1>Error</h1>
                <h3>Página no encontrada</h3>
                <Button type="button" label="Go back to home" onClick={goDashboard}></Button>
            </div>
            <div className="exception-footer">
                <img src={`assets/layout/images/ab/logoab.png`} className="exception-logo" alt="exception-logo" />
                {/* <img src={`assets/layout/images/appname-${props.colorScheme === 'light' ? 'dark' : 'light'}.png`} className="exception-appname" alt="exception-appname" /> */}
            </div>
        </div>
    );
};
